export default __webpack_public_path__ + "static/media/ms-icon-310x310.1aed5edd.png";